import type { VipTier } from './components/VipContext'

export const APPLE_STOREKIT_PRODUCTS = {
  vip: 'com.deepcubetech.sunharvest.vip',
  svip: 'com.deepcubetech.sunharvest.svip'
} as const

export type NativeStoreKitAction = 'purchase' | 'restore' | 'finish'

type StoreKitMessageHandler = {
  postMessage: (message: { action: NativeStoreKitAction; tier?: VipTier; transactionId?: string }) => void
}

type WebKitWindow = Window & {
  webkit?: {
    messageHandlers?: {
      storeKit?: StoreKitMessageHandler
    }
  }
}

export type NativeStoreKitEvent = {
  source: 'sun-storekit'
  event: 'purchase' | 'restore'
  status: 'success' | 'pending' | 'cancelled' | 'failed' | 'empty'
  productId?: string
  transactionId?: string
  message?: string
}

export function storeKitHandler(): StoreKitMessageHandler | null {
  if (typeof window === 'undefined') return null
  return (window as WebKitWindow).webkit?.messageHandlers?.storeKit || null
}

export function nativeStoreKitAvailable(): boolean {
  return Boolean(storeKitHandler())
}

export function requestNativeStoreKitPurchase(tier: VipTier): boolean {
  const handler = storeKitHandler()
  if (!handler) return false
  handler.postMessage({ action: 'purchase', tier })
  return true
}

export function requestNativeStoreKitRestore(): boolean {
  const handler = storeKitHandler()
  if (!handler) return false
  handler.postMessage({ action: 'restore' })
  return true
}

export function finishNativeStoreKitTransaction(transactionId: string): boolean {
  const handler = storeKitHandler()
  if (!handler) return false
  handler.postMessage({ action: 'finish', transactionId })
  return true
}
